import type { ButtonHTMLAttributes } from 'react'
import { buttonClass, type ButtonSize, type ButtonVariant } from './styles'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant; size?: ButtonSize; block?: boolean }

export function Button({ variant = 'primary', size = 'lg', block, className = '', type = 'button', ...rest }: Props) {
  return <button type={type} className={buttonClass(variant, size, `${block ? 'w-full' : ''} ${className}`)} {...rest} />
}

type IconProps = ButtonHTMLAttributes<HTMLButtonElement> & { label: string }

/** 44px round target with a required accessible name. */
export function IconButton({ label, className = '', type = 'button', children, ...rest }: IconProps) {
  return (
    <button type={type} aria-label={label} title={label}
      className={`press inline-flex size-11 shrink-0 items-center justify-center rounded-full text-ink active:bg-sunk disabled:opacity-30 ${className}`}
      {...rest}>
      {children}
    </button>
  )
}
